export default __webpack_public_path__ + "static/media/Planet.818c4347.png";